import React from 'react';
import { TableOfContents } from '../../components/articles/TableOfContents';
import { ArticlePartnerOffers } from '../../components/partners/ArticlePartnerOffers';
export const ArticleSidebar = ({article}) => <aside className="hidden lg:block lg:col-span-4"><div className="mb-6"><TableOfContents content={article.content}/></div><div className=""><ArticlePartnerOffers article={article} placement="sidebar"/></div></aside>;
